import React from "react";
import { useTranslate } from "ra-core";
import { Alert } from '@material-ui/lab';

const ProcessingPreviewAlert = () => {
    const translate = useTranslate();
    return (
        <Alert severity="info">{translate(`cmss.resources.file.the-preview-of-the-resource-is-under-processing`)}</Alert>
    );
}

export default ProcessingPreviewAlert;